module.exports = __webpack_public_path__ + "img/PlayNegro.706e51bc.svg";